import { render } from "./review-source-logo.vue?vue&type=template&id=2f95cb3a"
import script from "./review-source-logo.vue?vue&type=script&lang=js"
export * from "./review-source-logo.vue?vue&type=script&lang=js"

import "./review-source-logo.vue?vue&type=style&index=0&id=2f95cb3a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-testimonial/review-source-logo.vue'],['render',render],['__file',"review-source-logo.vue"]])

export default __exports__